<template>
  <div class="flex float-left vertical-center">
    <vs-button
      v-bind:id="'btn-configure-'+rowNumber"
      size="small"
      icon-pack="feather"
      icon="icon-settings"
      @click="configureRecord"
      v-if="isConfigure"
      color="dark"
      class="mr-2"
    ></vs-button>
    <vs-button
      v-bind:id="'btn-detail-'+rowNumber"
      size="small"
      icon-pack="feather"
      icon="icon-list"
      @click="detailRecord"
      color="primary"
      v-if="isDetail"
      class="mr-2"
    ></vs-button>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "ActionTableAgGridComponent",
  data() {
    return {
      isConfigure: false,
      isDetail: false,
      rowNumber: 0,
    };
  },
  methods: {
    detailRecord() {
      this.$root.$emit(
        "detail-from-ActionTableAgGridComponent",
        this.params.value
      );
    },
    configureRecord() {
      this.$root.$emit(
        "configure-from-ActionTableAgGridComponent",
        this.params.value
      );
    }
  },
  created() {
    if (this.params.data.status !== 'cancel') {
        this.isConfigure = true
    }
    this.isDetail = true;
    this.rowNumber = this.params.data.no;
  }
});
</script>

<style scoped>
.vertical-center {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
</style>